export default {
  hero: {
    title: 'Global Data 소개',
    subtitle: '혁신 기술로 미래를 연결합니다'
  },

  companyIntro: {
    title: '회사 소개',
    paragraph1: 'Global Data는 아시아태평양 지역의 IT 인프라 서비스에 특화된 선도 기업입니다. 현지 시장에 대한 깊은 이해와 글로벌 기술 시야를 바탕으로 기업의 디지털 전환을 위한 탄탄한 기반을 구축해 왔습니다. 지난 20여 년 동안 다수의 세계적인 기업에 효율적이고 안전하며 신뢰할 수 있는 서비스를 지속적으로 제공해 왔습니다.',
    paragraph2: '당사의 서비스 네트워크는 아시아태평양 주요 비즈니스 거점을 아우릅니다. 현지 팀과 글로벌 자원을 결합하여 다국적 기업과 지역 기관 모두에게 끊김 없는 기술 솔루션을 제공합니다. 인프라 기획부터 구축과 운영, 유지보수까지 Global Data는 고객의 디지털 전환 여정을 전 단계에서 함께합니다.'
  },

  missionVision: {
    title: '우리의 미션과 비전',
    mission: {
      title: '미션',
      content: '혁신 기술과 고품질 서비스를 통해 기업의 디지털 전환을 지원하고 운영 효율을 높이며 지속 가능한 비즈니스 성장을 이끄는 것입니다.'
    },
    vision: {
      title: '비전',
      content: '아시아태평양 IT 인프라 관리 분야에서 신뢰받는 파트너가 되어 기술 혁신과 서비스 고도화를 통해 인프라 현대화와 비즈니스 성장의 시너지를 실현하는 것입니다.'
    }
  },

  certifications: {
    title: '자격 및 인증',
    items: {
      iso9001: {
        name: 'ISO 9001',
        description: '품질경영시스템 인증'
      },
      iso27001: {
        name: 'ISO 27001',
        description: '정보보호 관리체계 인증'
      },
      idcIsp: {
        name: 'IDC/ISP',
        description: '중국 본토 데이터센터 자격'
      },
      imda: {
        name: 'IMDA',
        description: '싱가포르 IMDA 인증'
      },
      microsoft: {
        name: 'Microsoft 파트너',
        description: '골드 인증 파트너'
      },
      aws: {
        name: 'AWS 파트너',
        description: '고급 컨설팅 파트너'
      },
      huawei: {
        name: 'Huawei Cloud 파트너',
        description: '솔루션 파트너'
      },
      award: {
        name: '업계 우수상',
        description: '아시아태평양 IT 서비스 혁신상'
      }
    }
  },

  serviceNetwork: {
    title: '아시아태평양 서비스 네트워크',
    subtitle: '홈페이지 서비스 지도와 동일한 11개 아시아태평양 서비스 지역을 커버하며 현지화된 IT 인프라 서비스와 지역 협업 제공 역량을 제공합니다',
    serviceScopeLabel: '서비스 범위',
    regions: {
      china: {
        name: '중국 본토',
        subtitle: '중국 본토 서비스 센터',
        offices: {
          shanghai: {
            title: '상하이 서비스 센터',
            address: 'Room 1003-1, Guangming Real Estate Building, No. 199 Xizang North Road, Jing\'an District, Shanghai, China'
          },
          beijing: {
            title: '베이징 서비스 센터',
            address: 'No. 18, Jingjia Road, Yanqi Town, Huairou District, Beijing, China'
          },
          guangzhou: {
            title: '선전 서비스 센터',
            address: 'Unit 55, Room 1407, Building B, Phase 1, Tian\'an Innovation Technology Plaza, No. 4 Tairan Road, Futian District, Shenzhen, China'
          }
        },
        serviceScope: '중국 전역에서 데이터센터 구축 및 운영, 클라우드 솔루션, 네트워크 보안 서비스, IT 컨설팅을 제공합니다'
      },
      hongkong: {
        name: '홍콩',
        subtitle: '홍콩 서비스 센터',
        offices: {
          hq: {
            title: '홍콩 서비스 센터',
            address: 'Room A, 1/F., Arthur Commercial Building, 33 Arthur Road, Yau Ma Tei, Kowloon, Hong Kong'
          }
        },
        serviceScope: '홍콩 및 국제 비즈니스 허브 역할을 수행하며 국경 간 데이터센터 연결, 국제 네트워크 서비스, 핀테크 솔루션을 제공합니다',
        highlight: {
          title: '국제 비즈니스 강점',
          content: '중국 본토와 글로벌 시장을 연결하는 거점으로서 저지연 국경 간 데이터 전송과 국제 컴플라이언스 자문을 제공합니다'
        }
      },
      taiwan: {
        name: '타이베이',
        subtitle: '타이베이 서비스 센터',
        offices: {
          taipei: {
            title: '타이베이 서비스 센터',
            address: ''
          },
          hsinchu: {
            title: '신주 서비스 센터',
            address: ''
          }
        },
        serviceScope: '대만 전역에서 첨단 제조업 IT 솔루션, 클라우드 서비스, 데이터 보안 관리를 중심으로 지원합니다'
      },
      japan: {
        name: '일본',
        subtitle: '일본 서비스 센터',
        offices: {
          tokyo: {
            title: '도쿄 서비스 센터',
            address: '208, 2-9-17 HIGASHITABATA, KITA-KU, TOKYO 114-0013, JAPAN'
          },
          osaka: {
            title: '오사카 서비스 센터',
            address: ''
          }
        },
        serviceScope: '일본 전역에서 엔터프라이즈 IT 인프라 관리, 클라우드 이전, 일본어 현지 기술 지원 서비스를 제공합니다'
      },
      korea: {
        name: '대한민국',
        subtitle: '한국 서비스 센터',
        offices: {
          seoul: {
            title: '서울 서비스 센터',
            address: ''
          }
        },
        serviceScope: '대한민국 및 인접 지역에서 기업 클라우드 전환, 데이터센터 현대화, 한국어 기술 지원을 중심으로 서비스를 제공합니다',
        highlight: {
          title: '기술 전문성',
          content: '반도체 및 전자 제조 산업을 위한 IT 솔루션 분야에서 풍부한 경험과 전문성을 보유하고 있습니다'
        }
      },
      singapore: {
        name: '싱가포르',
        subtitle: '싱가포르 서비스 센터',
        offices: {
          hq: {
            title: '싱가포르 서비스 센터',
            address: '10 ANSON ROAD #27-18 INTERNATIONAL PLAZA SINGAPORE (079903)'
          }
        },
        serviceScope: '싱가포르 및 동남아시아 주변 지역에서 지역 IT 인프라 관리, 클라우드 서비스, 국경 간 데이터 컴플라이언스 솔루션을 제공합니다',
        highlight: {
          title: '지역 허브 강점',
          content: '동남아시아 비즈니스 허브로서 다국어 지원과 ASEAN 데이터 보호 규정에 부합하는 IT 솔루션을 제공합니다'
        }
      }
    }
  },

  cta: {
    title: '지금 당사 솔루션을 경험해 보세요',
    description: 'Global Data는 최첨단 기술 솔루션을 제공합니다. 당사의 제품은 이미 수백 개 기업의 디지털 전환, 운영 효율 향상, 비즈니스 성장 가속화를 지원해 왔습니다.',
    button: '문의하기'
  }
}
